module.exports = __webpack_public_path__ + "static/media/hiEducIcon.315adab0.svg";